import {
  NAVIGATION_TOGGLE_MENU,
  NAVIGATION_CHANGE_CATEGORY,
} from '../actions/desktop';

export default (state, action) => {
  if (!state) {
    return {
      openCategory: null,
      open: false,
      rootCategories: undefined,
    };
  }

  switch (action.type) {
    case 'CATEGORIES_RECEIVE': {
      return {
        ...state,
        rootCategories: action.categories,
      };
    }
    case NAVIGATION_TOGGLE_MENU: {
      const { open } = action;

      return {
        ...state,
        open,
      };
    }
    case NAVIGATION_CHANGE_CATEGORY: {
      const { openCategory } = action;

      return {
        ...state,
        openCategory,
      };
    }
    default:
  }

  return state;
};
